export const RESOURCE_NAME = 'personnel';

export const ENTITY_NAME = 'personnel';
